export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.dev) return

  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
    if (msg.includes('Slot "default" invoked outside of the render function')) return
    console.warn('[Vue warn]:', msg, trace)
  }
})
